import * as types from "./types";

const mutations = { 
    [types.LOADING_SEGMENT](state, value) {
        state.loading = value;
    },
    [types.GET_SEGMENTS](state, segments) {
        state.segments = segments;
    },
    [types.REMOVE_SEGMENT](state, id) {        
        state.segments = state.segments.filter((x) => x.id !== id);        
    },
    [types.ADD_SEGMENT](state, segments) {        
        state.segments.segments.unshift(segments);
    },
    [types.UPDATE_SEGMENT](state, segments) {        
        const SegmentIndex = state.segments.findIndex((x) => x.id === segments.segmentId);
        state.segments[SegmentIndex] = segments;        
    },
    [types.GET_CUSTOMERS_BY_SEGMENT](state, customers) {
        state.customers = customers;
    }

};

export default mutations;